import { render, staticRenderFns } from "./MultipleDetails.vue?vue&type=template&id=322e8d3c&scoped=true&"
import script from "./MultipleDetails.vue?vue&type=script&lang=js&"
export * from "./MultipleDetails.vue?vue&type=script&lang=js&"
import style0 from "./MultipleDetails.vue?vue&type=style&index=0&id=322e8d3c&lang=sass&scoped=true&"
import style1 from "./MultipleDetails.vue?vue&type=style&index=1&id=322e8d3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e8d3c",
  null
  
)

export default component.exports